<!-- Body Section starts -->
<div>
    <div class="main ">
        <section class="admin-content">
            <div class="tab-content  custom-tab-content">
                <div class="view-users">
                    <div *ngIf="department" id="user-view" class="show">
                        <div class="color-blue mb-20">{{'department-system.DEPARTMENT INFORMATION' |translate}}</div>
                     
                        <div class="row">
                            <div class="col-xs-5">
                                <div class="row form-group">
                                    <div class="col-sm-6"> {{'operating-country.Operating Country Name' |translate}}</div>
                                    <div class="col-sm-6 text-right">{{department?.operatingCountryName}}</div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-sm-5">{{'operating-country.Department Name' |translate}}</div>
                                    <div class="col-sm-7 text-right">{{department?.name}}</div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-sm-3">{{'store-user.Email' |translate}}</div>
                                    <div class="col-sm-9 text-right"><a href="mailto:{{department?.email}}">{{department?.email}}</a></div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-sm-3">{{'store-user.Status' |translate}}</div>
                                    <div class="col-sm-9 text-right">{{rowStatus[department?.status]}}</div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-sm-8">{{'department-system.Email verified/whitelisted in Titan' |translate}}</div>
                                    <div class="col-sm-4 text-right" *ngIf="department?.whiteListed == true">{{'department-system.Yes' |translate  |translateKey}}</div>
                                    <div class="col-sm-4 text-right" *ngIf="department?.whiteListed == false">{{'department-system.No' |translate  |translateKey}}</div>
                                </div>
                            </div>
                            <div class="col-xs-7"></div>
                        </div>
                    </div> 
                </div>
            </div>
        </section>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/department/department-view.component.html